import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
//
// 빌드 타깃에 따라 셸이 갈린다. 산림청 보안점검 AE(관리자 페이지 노출) 조치다.
//
//   REACT_APP_TARGET=admin      → /cert/admin/ 에 올린다. 관리자 셸 전체.
//   그 외(기본 applicant)        → /cert/ 에 올린다. 인증기업 화면만.
//
// HashRouter 는 # 뒤를 서버로 보내지 않는다. 한 주소에 두 화면이 있으면
// Apache 가 둘을 구분할 수 없어 관리자 화면만 골라 막을 수가 없다.
// 주소를 나눠야 서버에서 IP 제한을 걸 수 있다.
//
// 여기서 조건 분기를 쓰지 않는 이유
//   `cond ? import(A) : import(B)` 로 쓰면 webpack 이 양쪽 모두를 청크로 만든다.
//   실행되지 않을 뿐 파일은 배포되므로, 주소를 알아내면 관리자 청크를 그대로
//   받아 볼 수 있다. 실제로 그렇게 나와서 이 방식을 버렸다.
//   대신 craco.config.js 의 별칭 ActiveLayout 이 빌드 타깃에 따라 서로 다른
//   파일을 가리킨다. 선택되지 않은 쪽은 import 그래프에 아예 없다.
const TheLayout = React.lazy(() => import('ActiveLayout'));

// Pages
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'));
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'));

class App extends Component {

    render() {

        return (
            <HashRouter>
                <React.Suspense fallback={loading}>
                    <Switch>
                    <Route exact path="/404" name="Page 404" render={props => <Page404 {...props}/>} />
                    <Route exact path="/500" name="Page 500" render={props => <Page500 {...props}/>} />
                    <Route path="/" name="Home" render={props => <TheLayout {...props}/>} />
                    </Switch>
                </React.Suspense>
            </HashRouter>
        );
    }
}

export default App;
